// import { createCookieSessionStorage } from "react-router-dom";
import { StateStorage } from "zustand/middleware";

type CookieOptions = {
  path?: string;
  domain?: string;
  sameSite?: "Strict" | "Lax" | "None";
  secure?: boolean;
};

export const createCookieStorage = (
  options: CookieOptions = {}
): StateStorage => {
  const encode = (value: string) => encodeURIComponent(value);
  const decode = (value: string) => decodeURIComponent(value);

  const buildCookieString = (name: string, value: string) => {
    let cookie = `${encode(name)}=${encode(value)}`;
    if (options.path) cookie += `; Path=${options.path}`;
    if (options.domain) cookie += `; Domain=${options.domain}`;
    if (options.sameSite) cookie += `; SameSite=${options.sameSite}`;
    if (options.secure) cookie += `; Secure`;
    return cookie;
  };

  return {
    getItem: (name) => {
      const match = document.cookie.match(`(?:^|; )${encode(name)}=([^;]*)`);
      return match ? decode(match[1]) : null;
    },
    setItem: (name, value) => {
      document.cookie = buildCookieString(name, value);
    },
    removeItem: (name) => {
      document.cookie =
        buildCookieString(name, "") + "; Expires=Thu, 01 Jan 1970 00:00:00 GMT";
    },
  };
};
// const scopedStorage = createCookieSessionStorage({
//   cookie: {
//     name: `${getStorageKey("session")}`,
//     path: `/${process.env.REACT_APP_SITE_ID}`,
//     domain: `${window.location.hostname}`,
//     sameSite: "none",
//     secure: true,
//     httpOnly: false, // must be false for client-side access
//   },
// });
